import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConvexReactClient } from 'convex/react';
import { setApiAdapter } from '@/lib/apiAdapter';
import App from './App';
import { createWebApiAdapter } from './lib/webApiAdapter';
import './index.css';

const convexUrl = (import.meta.env.VITE_CONVEX_URL ?? '').trim();
const hasConvex = convexUrl.length > 0 && convexUrl.startsWith('https://');

setApiAdapter(createWebApiAdapter());

// v5: Force verbose true for production debugging
const client = hasConvex
  ? new ConvexReactClient(convexUrl, {
    verbose: true,
  })
  : null;

function Root() {
  return <App client={client} />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Root />
);
